const DEFAULT_ROUTE_BY_ROLE = Object.freeze({
  admin: '/dashboard',
  user: '/leads',
});

const FALLBACK_AUTHENTICATED_ROUTE = '/quotes';

export const getDefaultRouteForRole = (role, fallback = FALLBACK_AUTHENTICATED_ROUTE) =>
  DEFAULT_ROUTE_BY_ROLE[role] || fallback;

export default DEFAULT_ROUTE_BY_ROLE;
